export const LOAD_MINI_CART_DATA_ASYNC = 'LOAD_MINI_CART_DATA_ASYNC';
export const MINI_CART_DATA_LOADED = 'MINI_CART_DATA_LOADED';
export const LOAD_MINI_CART_DATA_ASYNC_FAIL = 'LOAD_MINI_CART_DATA_ASYNC_FAIL';
export const SET_MINI_CART_ORDER_ID = 'SET_MINI_CART_ORDER_ID';
export const SET_MINI_CART_OPEN = "SET_MINI_CART_OPEN";
